
import { CommonModule } from '@angular/common';
import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { ToolComponent } from '@igo2/common/tool';
import { IgoMap, PrintComponent, PrintFormComponent } from '@igo2/geo';
import { MapState } from '@igo2/integration';

@ToolComponent({
  name: 'sigt-print',
  title: 'igo.integration.tools.print',
  icon: 'print'
})

@Component({
    selector: 'sigt-print-tool',
    //showPrint : hack to force re-rendering of PrintFormComponent
    template: `
    <igo-print *ngIf="showPrint" [map]="map" [legendPosition]="legendPosition"></igo-print>
  `,
    imports: [
        CommonModule,
        PrintComponent
    ]
})
export class SigtPrintToolComponent implements AfterViewInit {
  @ViewChild(PrintComponent)
  public printComponent: PrintComponent;

  public showPrint = true;
  public legendPosition = 'newpage';

  get map(): IgoMap {
    return this.mapState.map;
  }

  constructor(
    private mapState: MapState
    ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
       this.showPrint = true;      
    }, 100);
  }
}
